(() => {
  const label = value => String(value || '').normalize('NFC').trim().replace(/\s+/g, ' ').toLocaleLowerCase('nl');
  // Only Bridge-verified native Shopify exact pages may become navigation targets.
  // DRAFT or malformed URLs retain the exact UUID and use the existing NEW browse route.
  const nativeExactPage = (raw, shopUrl) => {
    if (typeof raw !== 'string' || !raw.trim()) return null;
    try {
      const shop = new URL(shopUrl);
      const target = new URL(raw, shop.origin);
      return shop.protocol === 'https:' && target.protocol === 'https:'
        && target.origin === shop.origin && !target.username && !target.password
        && !target.search && !target.hash
        && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/[^/]+\/[^/]+\/?$/.test(target.pathname)
        ? target.href : null;
    } catch (_) { return null; }
  };
  const initialize = async root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const status = root.querySelector('[data-bm-executions-status]');
    const options = root.querySelector('[data-bm-executions-options]');
    const retry = root.querySelector('[data-bm-executions-retry]');
    let selectionVersion = 0;
    const load = async () => {
      options.replaceChildren(); retry.hidden = true; status.textContent = 'Uitvoeringen laden…';
      try {
        const client = window.BandenmeestersNewClient;
        const brandRef = root.dataset.brandRef;
        if (!brandRef) { status.textContent = 'Kies merk en model via Mijn Auto om je exacte uitvoering te selecteren.'; return; }
        const models = (await client.vehicleModels(brandRef)).models;
        const matches = models.filter(model => label(model.label) === label(root.dataset.modelName));
        if (matches.length !== 1) { status.textContent = 'De modelkoppeling moet nog worden bevestigd. Kies je auto via Mijn Auto.'; return; }
        const model = matches[0];
        const types = (await client.vehicleTypes(brandRef, model.ref)).types;
        if (!root.isConnected) return;
        for (const type of types) {
          const button = document.createElement('button'); button.type = 'button';
          button.textContent = [type.label, type.yearFrom ? `${type.yearFrom}${type.yearTo ? '–' + type.yearTo : ''}` : ''].filter(Boolean).join(' · ');
          button.addEventListener('click', () => {
            // USED-only release: source-backed navigation, no NEW cart, supplier calls or fitment claims.
            const publicPage = nativeExactPage(type.vehiclePageUrl, root.dataset.shopUrl);
            const previewPage = publicPage ? null : client.unpublishedVehiclePagePreviewUrl?.(
              type, { themeRole: root.dataset.bmThemeRole }
            ) || null;
            const destination = publicPage || previewPage;
            if (!destination) {
              status.textContent = 'Deze exacte voertuigpagina is nog niet openbaar. Kies een andere uitvoering of probeer later opnieuw.';
              return;
            }
            const next = new URL(destination, window.location.origin);
            const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
            if (/^\d+$/.test(previewId || '') && next.origin === window.location.origin) {
              next.searchParams.set('preview_theme_id', previewId);
            }
            window.location.assign(next.href);
          });
          options.append(button);
        }
        status.textContent = types.length ? `${types.length} beschikbare uitvoeringen` : 'Er zijn momenteel geen beschikbare uitvoeringen voor dit model.';
      } catch (_) { status.textContent = 'Uitvoeringen konden niet worden geladen.'; retry.hidden = false; }
    };
    retry.addEventListener('click', load); await load();
  };
  const initializeAll = () => document.querySelectorAll('[data-bm-model-executions]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, {once:true}); else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
